const LoginPage = () => import('./views/LoginPage.vue');
const PasswordResetPage = () => import('./views/PasswordResetPage.vue');

export default [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      public: true,
    },
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: PasswordResetPage,
    meta: {
      public: true,
    },
  },
];
